import React from 'react'

export default function(props) {
    const { children } = props

    return (
        <div className="modal-body">
            { children }
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/Shared/ModalBody.jsx